module.exports = __webpack_public_path__ + "static/img/leftc9.754bec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/leftc9.png
// module id = LU/m
// module chunks = 37